import { useAppStore } from '@/store/app';
import { PortfolioAssetO, PortfolioElementO } from '@/types';
import { computed, ComputedRef, ref } from 'vue';

type Params = {
  elements: ComputedRef<PortfolioElementO[]>;
  assetWalletTokens: ComputedRef<PortfolioAssetO[]>;
};

export default function useHiddenElementsValue({
  elements,
  assetWalletTokens,
}: Params) {
  const appStore = useAppStore();

  const hiddenElements = computed(() =>
    elements.value.filter(
      (e) => e.value && e.value < appStore.minDisplayedValue,
    ),
  );

  const hiddenWalletTokens = computed(() =>
    assetWalletTokens.value.filter(
      (a) => a.value && a.value < appStore.minDisplayedValue,
    ),
  );

  const hiddenElementsValue = computed(() => {
    const sumHiddenElements = hiddenElements.value.reduce((sum: number, e) => {
      return sum + (e.value || 0);
    }, 0);

    const sumHiddenWalletTokens = hiddenWalletTokens.value.reduce(
      (sum: number, e) => {
        return sum + (e.value || 0);
      },
      0,
    );

    return sumHiddenElements + sumHiddenWalletTokens;
  });

  return { hiddenElementsValue };
}
